import { ComponentType } from 'react';

import { ComposeProvider } from '@Components/shared/providers/ComposeProvider';

// Providers
import { CreateProviderFormProvider } from '@Features/providers/forms/providers/CreateProviderFormProvider';
import { SetupProviderFormProvider } from '@Features/providers/forms/providers/SetupProviderFormProvider';

// Rounds
import { CreateRoundConfigFormProvider } from '@Features/providers/forms/rounds/CreateRoundConfigFormProvider';

// AviatorUsers
import { CreateAviatorUserFormProvider } from '@Features/providers/forms/roles/CreateAviatorUserFormProvider';

// AviatorRoles
import { CreateAviatorRoleFormProvider } from '@Features/providers/forms/aviatorRoles/CreateAviatorRoleFormProvider';
import { CreateProviderConfigFormProvider } from '@Features/providers/forms/providers/CreateProviderConfigFormProvider';
import { CreateAviatorPermissionFormProvider } from '@Features/providers/forms/aviatorPermissions/CreateAviatorPermissionFormProvider';
import { AddRolePermissionsFormProvider } from '@Features/providers/forms/aviatorPermissions/AddRolePermissionsFormProvider';
// Localizations
import { CreateLocalizationKeyFormProvider } from '@Features/providers/forms/localizations/CreateLocalizationKeyFormProvider';
import { TestsFormProvider } from '@Features/providers/forms/tests/TestsFormProvider';
import { CreateRaindropFormProvider } from '@Features/providers/forms/raindrop/CreateRaindropFormProvider';
import { SetupUserFormProvider } from '@Features/providers/forms/users/SetupUserFormProvider';
import { CreateCampaignFormProvider } from '@Features/providers/forms/campaigns/CreateCampaignFormProvider';
import { CreateFreebetsFormProvider } from '@Features/providers/forms/freebets/CreateFreebetsFormProvider';
import { RevokeFreebetsFormProvider } from '@Features/providers/forms/freebets/RevokeFreebetsFormProvider';
import { SetupCampaignFormProvider } from '@Features/providers/forms/campaigns/SetupCampaignFormProvider';

const providers: ComponentType<{ children: JSX.Element }>[] = [
  CreateProviderFormProvider,
  SetupProviderFormProvider,
  CreateRoundConfigFormProvider,
  CreateAviatorUserFormProvider,
  CreateAviatorRoleFormProvider,
  CreateProviderConfigFormProvider,
  CreateAviatorPermissionFormProvider,
  AddRolePermissionsFormProvider,
  CreateLocalizationKeyFormProvider,
  TestsFormProvider,
  CreateRaindropFormProvider,
  SetupUserFormProvider,
  CreateCampaignFormProvider,
  CreateFreebetsFormProvider,
  RevokeFreebetsFormProvider,
  SetupCampaignFormProvider,
];

type Props = { children: JSX.Element | JSX.Element[] };

export const StoreContainer: React.FC<Props> = ({ children }) => {
  return (
    <ComposeProvider providers={providers}>
      <>{children}</>
    </ComposeProvider>
  );
};
